module.exports = __webpack_public_path__ + "static/img/logo_vonage-light.7b7160e9.png";